module.exports = fox._r("images/sprite-2.png", __webpack_public_path__ + "images/sprite-2.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/sprite-2.png
// module id = 1128
// module chunks = 4